// Function to load a script dynamically using a Promise
function loadScript(src) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

// Main function to handle time-based messaging and countdown
async function setupShippingMessage() {
  // Load Day.js and its plugins
  try {
    await loadScript('https://cdn.jsdelivr.net/npm/dayjs@1/dayjs.min.js');
    await loadScript('https://cdn.jsdelivr.net/npm/dayjs@1/plugin/utc.js');
    await loadScript('https://cdn.jsdelivr.net/npm/dayjs@1/plugin/timezone.js');
    await loadScript('https://cdn.jsdelivr.net/npm/dayjs@1/plugin/duration.js');
    dayjs.extend(dayjs_plugin_utc);
    dayjs.extend(dayjs_plugin_timezone);
    dayjs.extend(dayjs_plugin_duration);
  } catch (error) {
    console.error('Failed to load required scripts:', error);
    return;
  }

  const ORDER_CUTOFF_HOUR = 15; // 3 PM Eastern Time

  function chkTime() {
    const now = dayjs().tz('America/New_York');
    const hrs = now.hour();
    const mins = now.minute();
    const dayOfDate = now.day(); // 0 = Sunday, 1 = Monday...

    let msg = '';
    let isAfterCutoff = hrs >= ORDER_CUTOFF_HOUR;
    
    // Define the weekend/non-shipping period
    // This is true if it's Saturday (6), Sunday (0), or Friday (5) after 3 PM
    const isExtendedWeekend = (dayOfDate === 6 || dayOfDate === 0 || (dayOfDate === 5 && isAfterCutoff));

    // Determine the next cutoff time
    let nextCutoff = now.clone().hour(ORDER_CUTOFF_HOUR).minute(0).second(0);
    
    // Logic to set the target for the countdown
    if (isExtendedWeekend) {
        // Next cutoff is Monday at 3 PM
        let daysUntilMonday = 0;
        if (dayOfDate === 5) daysUntilMonday = 3; // Friday -> Monday
        else if (dayOfDate === 6) daysUntilMonday = 2; // Saturday -> Monday
        else if (dayOfDate === 0) daysUntilMonday = 1; // Sunday -> Monday
        
        nextCutoff = now.add(daysUntilMonday, 'day').hour(ORDER_CUTOFF_HOUR).minute(0).second(0);
    } else if (isAfterCutoff && dayOfDate !== 5) {
        // Weekdays (Mon-Thu) after 3 PM, next cutoff is tomorrow at 3 PM
        nextCutoff = now.add(1, 'day').hour(ORDER_CUTOFF_HOUR).minute(0).second(0);
    }

    
    // --- CONSOLIDATED WEEKEND LOGIC ---
    if (isExtendedWeekend) {
        const remainingDuration = dayjs.duration(nextCutoff.diff(now));
        
        let daysRemaining = Math.floor(remainingDuration.asDays());
        let hoursRemaining = remainingDuration.hours();
        let minutesRemaining = remainingDuration.minutes();

        // Package ships Monday
        const shipDate = now.add(daysRemaining, 'day').startOf('day').day(1); // Find the next Monday
        
        // Estimated Delivery is Tuesday to Wednesday
        const estDeliveryStart = shipDate.add(1, 'day').format('ddd, MMM D'); // Tuesday
        const estDeliveryEnd = shipDate.add(2, 'days').format('ddd, MMM D'); // Wednesday
        
        msg = `<strong>Ships Monday</strong>, if ordered in the next <span class="free-ship-time-left">${daysRemaining > 0 ? daysRemaining + ' days ' : ''}${hoursRemaining} hours</span><br><strong>Estimated delivery</strong>: ${estDeliveryStart} to ${estDeliveryEnd}`;

    } 
    // --- WEEKDAY LOGIC (Mon - Fri before 3 PM) ---
    else if (!isAfterCutoff) { 
      const remainingHours = ORDER_CUTOFF_HOUR - hrs - (mins > 0 ? 1 : 0);
      const remainingMinutes = 60 - mins;
      
      let estDeliveryStart = now.add(1, 'day').format('ddd, MMM D');
      let estDeliveryEnd = now.add(3, 'days').format('ddd, MMM D');

      if (dayOfDate === 5) { // Friday before 3 PM
        estDeliveryEnd = now.add(3, 'days').format('ddd, MMM D'); // Delivery Saturday to Tuesday
      }

      msg = `<strong>Ships today</strong>, if ordered in the next <span class="free-ship-time-left">${remainingHours} hrs ${remainingMinutes} mins</span><br><strong>Estimated delivery</strong>: ${estDeliveryStart} to ${estDeliveryEnd}`;

    } 
    // --- WEEKDAY LOGIC (Mon - Thu after 3 PM) ---
    else { 
      const remainingDuration = dayjs.duration(nextCutoff.diff(now));
      
      let hoursRemaining = remainingDuration.hours();
      let minutesRemaining = remainingDuration.minutes();

      // Determine the next shipping day
      const shipDate = now.add(1, 'day'); // Ships tomorrow
      let shippingMessage = `<strong>Ships tomorrow</strong>, if ordered in the next`;

      // Determine the delivery dates based on the ship date (Tomorrow)
      let estDeliveryStart, estDeliveryEnd;
      
      // The previous issue (Thursday after 3 PM) is fixed here:
      if (dayOfDate === 4) { // Thursday after cutoff -> Ships Friday
        estDeliveryStart = shipDate.add(1, 'day').format('ddd, MMM D'); // Friday + 1 day = Saturday
        estDeliveryEnd = shipDate.add(4, 'days').format('ddd, MMM D'); // Friday + 3 days = Tuesday
      } else if (dayOfDate === 3) { // Wednesday after cutoff -> Ships Thursday
        estDeliveryStart = shipDate.add(1, 'day').format('ddd, MMM D'); // Thursday + 1 day = Friday
        estDeliveryEnd = shipDate.add(4, 'days').format('ddd, MMM D'); // Thursday + 2 days = Saturday
      } else { // Monday/Tuesday after cutoff -> Ships Tuesday/Wednesday
        estDeliveryStart = shipDate.add(1, 'day').format('ddd, MMM D');
        estDeliveryEnd = shipDate.add(3, 'days').format('ddd, MMM D');
      }

      msg = `${shippingMessage} <span class="free-ship-time-left">${hoursRemaining} hrs ${minutesRemaining} mins</span><br><strong>Estimated delivery</strong>: ${estDeliveryStart} to ${estDeliveryEnd}`;
    }

    // Update the DOM with the generated message
    $('#custom_message, .custom_message').css('display', 'block').html(`
      <span class="custom-shipping-message">${msg}</span>
      <span class="info-ship"><img src="https://cdn.shopify.com/s/files/1/0700/5519/8950/files/info-msg.svg?v=1729838946" /></span>
      <span class="popup-box-message"><p>We try to keep all products in stock at all of our warehouses, but sometimes we might be out of stock of a product in the warehouse nearest to you. In these instances, shipping times might take longer than 1-3 business days.</p><p>Thanks for your understanding.</p></span>
    `);
  }

  // Run the check immediately and then every second
  $(function() {
    chkTime();
    setInterval(chkTime, 1000);
  });
}

// Call the main function to start the process
setupShippingMessage();

//////////////////////////END OF SHIPPING TIME SCRIPT///////////////////////////////////

setTimeout(function() { 
  $("a.Chat").attr("data-reamaze-lightbox", "contact");
  $('a.Meteor-Navigation__Link__desktop svg').parent('a').addClass('have-nav');
}, 5000); 

$(document).ready(function(e) {

$('.custom-select__option').on('click', function() {
  setTimeout(function() { 
  calculatereward();
   }, 1000);  
});

function calculatereward(){
  var defaultPrice = $('.price__default strong.price__current').text().replace('$', '').trim();
  //console.log(defaultPrice );
  // Convert the extracted price to a number
  var numericPrice = parseFloat(defaultPrice);
  //console.log(numericPrice);
  // Check if the extracted price is a valid number
  if (!isNaN(numericPrice)) {
    // Calculate 5% of the price
    var reward = (numericPrice * 0.05).toFixed(2); // Keep it to 2 decimal places
    $('#reward').text("$"+ reward);
  
    // Log the 5% reward value to the console
    //console.log("5% of the price is: $" + reward);
  } else {
    //console.log("Invalid price value");
  }
}

calculatereward();
  
});	

  setInterval(function() {
    // Check if <s> tag exists inside #CartsubTotal
    var cartSubTotalElement = $('#CartsubTotal');
    var subTotalPrice;

    if (cartSubTotalElement.find('s').length) {
        // Get the price not in the <s> tag
        subTotalPrice = cartSubTotalElement
            .clone() // Clone the element
            .children('s') // Remove the <s> tag and its content
            .remove()
            .end()
            .text()
            .trim();
    } else {
        // Use the full text if no <s> tag is present
        subTotalPrice = cartSubTotalElement.text().trim();
    }

    // Extract numeric value from the price text
    var subTotalPriceVal = parseFloat(subTotalPrice.replace('$', ''));

    // Calculate reward points
    var rewardPointsVal = (subTotalPriceVal / 100) * 5;
    var rewardPoints = rewardPointsVal.toFixed(2);

    console.log(rewardPoints);

    // Update the reward points value in the designated element
    $('.cart-reward #reward').text("$" + rewardPoints);
}, 500);
